export default __webpack_public_path__ + "925e6b2e90118d6f558595d71e9ada6b.png";